module.exports = __webpack_public_path__ + "img/7-8.c8ad0853.png";